import { render, staticRenderFns } from "./SttDictionaryAssignToTalkGroup.vue?vue&type=template&id=13a974f3&scoped=true"
import script from "./SttDictionaryAssignToTalkGroup.vue?vue&type=script&lang=js"
export * from "./SttDictionaryAssignToTalkGroup.vue?vue&type=script&lang=js"
import style0 from "./SttDictionaryAssignToTalkGroup.vue?vue&type=style&index=0&id=13a974f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a974f3",
  null
  
)

export default component.exports